export const isReferencing = (): boolean => {
  const selfQueryParams = new URLSearchParams(globalThis.location.search);
  return selfQueryParams.get('referencing') === 'true';
};
